import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { Eye } from 'lucide-react';

export default function DirectiveCard({ directive }) {
  const priority = directive.priority || 0;

  // Higher priority = more visual weight
  const intensity = Math.min(priority, 1);

  return (
    <Card className={cn(
      'transition-all',
      intensity > 0.8 && 'border-amber-500/30 shadow-amber-500/5 shadow-md',
      intensity > 0.5 && intensity <= 0.8 && 'border-primary/20 shadow-sm',
      intensity <= 0.5 && 'border-border',
    )}>
      <CardContent className="p-4 space-y-2">
        <div className="flex items-start gap-2">
          <Eye className={cn(
            'h-4 w-4 mt-0.5 shrink-0',
            intensity > 0.8 ? 'text-amber-400' : 'text-muted-foreground',
          )} />
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium leading-tight">{directive.focus}</div>
            <div className="text-xs text-muted-foreground mt-1 leading-relaxed">
              {directive.reason}
            </div>
          </div>
          <div className={cn(
            'text-xs font-mono tabular-nums shrink-0',
            intensity > 0.8 ? 'text-amber-400' : 'text-muted-foreground',
          )}>
            {(priority * 100).toFixed(0)}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
